import {EventEmitter} from 'events';
import {WixSdk} from '@wix/js-sdk-wrapper';

export const INCOMING_EVENTS = {
  INIT: 'remote-player.state-update.init',
  PLAYING: 'remote-player.state-update.playing',
  PAUSE: 'remote-player.state-update.pause',
  TIMEUPDATE: 'remote-player.state-update.timeupdate',
  ERROR: 'remote-player.state-update.error',
};

/**
 * Transport from widget to current window. Done via WixSdk.PubSub
 * Receives events from remote player.
 * Emits events like playing, timeupdate, pause, error.
 * Has additional event for init. Received when player is ready.
 */
export class IncomingTransport extends EventEmitter {
  private readonly originalComponentId: string;

  constructor(originalComponentId: string) {
    super();
    if (!originalComponentId) {
      throw new Error('originalComponentId is not specified');
    }
    this.originalComponentId = originalComponentId;
    this.__subscribeToEvents();
  }

  __subscribeToEvents() {
    Object.values(INCOMING_EVENTS).forEach((eventName) => {
      WixSdk.PubSub.subscribe(eventName, (event) => {
        const {origin, data} = event;

        if (!data || typeof data !== 'object') {
          throw new Error(`Unknown data format in event '${eventName}'`);
        }
        if (origin === this.originalComponentId) {
          this.emit(eventName, data);
        }
      });
    });
  }

  on(eventName, listener) {
    if (!Object.values(INCOMING_EVENTS).includes(eventName)) {
      throw new Error(`Unknown event ${eventName}`);
    }
    super.on(eventName, listener);
    return this;
  }

  addListener(eventName, listener) {
    return this.on(eventName, listener);
  }
}
